/* @flow */

export default class ISOAndCampaignRequest {
  campaignId: number;
  isoCompanyId: number;
  isoCompanyOfficeId: number;
  isoCompanyPersonId: number;
}